import { Component, ViewContainerRef, ElementRef, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { Validators, FormBuilder, FormGroup, ValidatorFn, AbstractControl } from '@angular/forms';
import { PhotoService } from '../../_services/photo.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogService } from '../../_services/dialog.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UPNService, UPNListView } from '../../../app/_services/upn.service';
import { UPN, UPNFileType, UPNServiceFileCollection } from '../../_models/UPN';
import { PaymentService } from '../../_services/payment-service.service';
import { map } from 'rxjs/operators';
import { Observable, forkJoin, Subject, of } from 'rxjs';
import { BaseCueServiceComponent as CueServiceComponentBase } from '../../_shared/base.cueservice.component';
import { UserService } from '../../_services/user.service';
import { CouponService } from '../../_services/coupon.service';
import * as moment from 'moment';
import { Coupon } from '../../_models/Coupon';
import { Environment } from '../../../environments/environment';
import { NgxIndexedDBService } from 'ngx-indexed-db';


@Component({
  selector: 'app-upn-form',
  templateUrl: './upn-form.component.html',
  styleUrls: ['./upn-form.component.css'],
})

export class UpnFormComponent extends CueServiceComponentBase<UPN, UPNListView> implements AfterViewInit, OnDestroy {
  public loadingMessage = 'Loading UPN data...';
  imgUrl = '';
  loadingFirstImage = false;
  loadingSecondImage = false;
  loadingThirdImage = false;
  public formLoaded = false;
  upnTypeList = ['Image', 'Web View', 'Map View'];
  //mySwiper: any;
  toggleSlider = true;
  buttonTypeList = ['openUrl', 'openMaps', 'openCoupon'];
  siteUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/t5CSY5eKkeQ');
  ngdestroy = new Subject();
  uploadPlaceholderImage = '../../assets/app/media/img/tools/add-upn-img.png';
  showServicePeriod: boolean;
  serviceFiles = new UPNServiceFileCollection();

  private _dropZoneEventListerners = ['dragenter', 'dragover', 'dragleave', 'drop'];
  private _hasSiteManagement = false;

  private _highlightFirstZone: () => void;
  private _highlightSecondZone: () => void;
  private _highlightThirdZone: () => void;

  private _unHighlightZones: () => void;

  private _handleFirstDrop: (e) => void;
  private _handleSecondDrop: (e) => void;
  private _handleThirdDrop: (e) => void;

  isOnTopOfFirstZone: boolean;
  isOnTopOfSecondZone: boolean;
  isOnTopOfThirdZone: boolean;

  get hasSiteManagement() {
    return this._hasSiteManagement;
  }

  coupons: Coupon[];
  @ViewChild('coupon1Select', {static: false})
  coupon1Select: ElementRef;
  @ViewChild('gmap', {static: false})
  mapElement: ElementRef;
  @ViewChild('firstDropZone', {static: false})
  firstDropZoneRef: ElementRef;
  @ViewChild('secondDropZone', {static: false})
  secondDropZoneRef: ElementRef;
  @ViewChild('thirdDropZone', {static: false})
  thirdDropZoneRef: ElementRef;

  // Only return native element on these controls if it exists
  get firstDropZone() {
    if (this.firstDropZoneRef) {
      return this.firstDropZoneRef.nativeElement as HTMLLabelElement;
    }
  }

  get secondDropZone() {
    if (this.secondDropZoneRef) {
      return this.secondDropZoneRef.nativeElement as HTMLLabelElement;
    }
  }

  get thirDropZone() {
    if (this.thirdDropZoneRef) {
      return this.thirdDropZoneRef.nativeElement as HTMLLabelElement;
    }
  }

  map: google.maps.Map;

  marker: google.maps.Marker;

  constructor(private fb: FormBuilder,
    public sanitizer: DomSanitizer,
    public photoService: PhotoService,
    public viewRef: ViewContainerRef,
    public spinner: NgxSpinnerService,
    public dialogService: DialogService,
    public router: Router,
    private upnService: UPNService,
    public paymentService: PaymentService,
    public route: ActivatedRoute,
    public userService: UserService,
    public couponService: CouponService,
    public dbService: NgxIndexedDBService
  ) {
    super(upnService, photoService, router, route, spinner, paymentService, dialogService, viewRef, userService, dbService);
  }

  ngAfterViewInit() {


    // TODO: No idea why the getters for first/second/third zones return undefined; It's inside afterviewinit also the *ngIf for form is true
    setTimeout(() => this._attachDragAndDropEventListeners(), 2000);
  }

  private _attachDragAndDropEventListeners() {
    this._highlightFirstZone = () => {
      this.isOnTopOfFirstZone = true;
      this.firstDropZone.classList.add('highlight');
    };

    this._highlightSecondZone = () => {
      this.isOnTopOfSecondZone = true;
      this.secondDropZone.classList.add('highlight');
    };

    this._highlightThirdZone = () => {
      this.isOnTopOfThirdZone = true;
      this.thirDropZone.classList.add('highlight');
    };

    this._unHighlightZones = () => {
      this.isOnTopOfFirstZone = false;
      this.isOnTopOfSecondZone = false;
      this.isOnTopOfThirdZone = false;

      this.secondDropZone.classList.remove('highlight');
      this.firstDropZone.classList.remove('highlight');
      this.thirDropZone.classList.remove('highlight');
    };

    this._handleFirstDrop = (e) => {
      const dt = e.dataTransfer;
      const files = dt.files;

      this.firstImageHandler(files);
    };

    this._handleSecondDrop = (e) => {
      const dt = e.dataTransfer;
      const files = dt.files;

      this.secondImageHandler(files);
    };

    this._handleThirdDrop = (e) => {
      const dt = e.dataTransfer;
      const files = dt.files;

      this.thirdImageHandler(files);
    };

    this._dropZoneEventListerners.forEach(eventName => {
      this.firstDropZone?.addEventListener(eventName, this._preventDefaults, false);
      this.secondDropZone?.addEventListener(eventName, this._preventDefaults, false);
      this.thirDropZone?.addEventListener(eventName, this._preventDefaults, false);
    });

    ['dragenter', 'dragover'].forEach(eventName => {
      this.firstDropZone?.addEventListener(eventName, this._highlightFirstZone, false);
      this.secondDropZone?.addEventListener(eventName, this._highlightSecondZone, false);
      this.thirDropZone?.addEventListener(eventName, this._highlightThirdZone, false);
    });

    ['dragleave', 'drop'].forEach(eventName => {
      this.firstDropZone?.addEventListener(eventName, this._unHighlightZones, false);
      this.secondDropZone?.addEventListener(eventName, this._unHighlightZones, false);
      this.thirDropZone?.addEventListener(eventName, this._unHighlightZones, false);
    });

    this.firstDropZone?.addEventListener('drop', this._handleFirstDrop, false);
    this.secondDropZone?.addEventListener('drop', this._handleSecondDrop, false);
    this.thirDropZone?.addEventListener('drop', this._handleThirdDrop, false);
  }

  private _preventDefaults(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  protected loadLookupData(): Observable<any> {
    const siteManagementObs = this.userService.hasSinglePermission('SiteManagement').pipe(map(sm => this._hasSiteManagement = sm));

    return forkJoin([siteManagementObs]);
  }

  public getFormData(form: FormGroup, includeServiceFiles: boolean = false): UPN {
    this._updateFormByUPNType(this.form.get('type').value);

    return {
      activePeriod: {
        startDate: this._formatDate(form.get('activePeriod').value.startDate),
        endDate: this._formatDate(form.get('activePeriod').value.endDate)
      },
      cooldown: form.get('cooldown').value,
      locationTitle: form.get('locationTitle').value,
      locationSubtitle: form.get('locationSubtitle').value,
      dismissText: form.get('dismissText').value,
      firstButtonLat: form.get('firstButtonLat').value,
      firstButtonLng: form.get('firstButtonLng').value,
      firstButtonText: form.get('firstButtonText').value,
      firstButtonType: form.get('firstButtonType').value,
      firstButtonUrl: form.get('firstButtonUrl').value,
      firstButtonLocationTitle: form.get('firstButtonLocationTitle').value,
      firstButtonLocationSubtitle: form.get('firstButtonLocationSubtitle').value,
      firstImage: form.get('firstImage').value,
      id: form.get('id').value,
      lat: form.get('lat').value,
      lng: form.get('lng').value,
      secondButtonLat: form.get('secondButtonLat').value,
      secondButtonLng: form.get('secondButtonLng').value,
      secondButtonText: form.get('secondButtonText').value,
      secondButtonType: form.get('secondButtonType').value,
      secondButtonUrl: form.get('secondButtonUrl').value,
      secondButtonLocationTitle: form.get('secondButtonLocationTitle').value,
      secondButtonLocationSubtitle: form.get('secondButtonLocationSubtitle').value,
      secondImage: form.get('secondImage').value,
      thirdImage: form.get('thirdImage').value,
      title: form.get('title').value,
      type: form.get('type').value,
      iframeUrl: form.get('iframeUrl').value,
      autoswipe: form.get('autoswipe').value,
      upnJson: null,
      bleEnabled: form.get('bleEnabled').value,
      bleTitle: form.get('bleTitle').value,
      bleSubtitle: form.get('bleSubtitle').value,
      bleBody: form.get('bleBody').value,
      bleShowOnTap: form.get('bleShowOnTap').value,
      coupon1Id: form.get('coupon1Select').value,
      coupon2Id: form.get('coupon2Select').value,
      regenerateAudio: form.get('regenerateAudio').value,
      useAudible: form.get('useAudible').value,
      dateCreated: new Date(Date.now()),
      serviceFiles: includeServiceFiles ? this.serviceFiles : null
    };
  }

  sanitizeUrl(form) {
    const isUrlValid = form.get('iframeUrl').valid;
    if (isUrlValid) {
      this.siteUrl = this.sanitizer.bypassSecurityTrustResourceUrl(form.get('iframeUrl').value);
    }
  }

  openGoogleMapsWithCoordinates(lat: number, lng: number) {
    const url = `https://www.google.com/maps/search/?api=1&query=${lng},${lat}`;
    window.open(url, '_blank');
  }

  markerUpdate() {
    const latControl = this.form.get('lat');
    const lngControl = this.form.get('lng');

    if (latControl.valid && lngControl.valid) {
      this.marker.setPosition({ lat: latControl.value, lng: lngControl.value });
      this.map.panTo({ lat: latControl.value, lng: lngControl.value });
    }
  }

  firstButtonClick() {
    if (this.form.get('firstButtonType').value === 'openUrl') {
      let url = '';
      if (!/^http[s]?:\/\//.test(this.form.get('firstButtonUrl').value)) {
        url += 'http://';
      }

      url += this.form.get('firstButtonUrl').value;
      window.open(url, '_blank');
    } else if (this.form.get('firstButtonType').value === 'openMaps') {
      this.openGoogleMapsWithCoordinates(this.form.get('firstButtonLng').value, this.form.get('firstButtonLat').value);
    }
  }

  secondButtonClick() {
    if (this.form.get('secondButtonType').value === 'openUrl') {
      let url = '';
      if (!/^http[s]?:\/\//.test(this.form.get('secondButtonUrl').value)) {
        url += 'http://';
      }

      url += this.form.get('secondButtonUrl').value;
      window.open(url, '_blank');
    } else if (this.form.get('secondButtonType').value === 'openMaps') {
      this.openGoogleMapsWithCoordinates(this.form.get('secondButtonLng').value, this.form.get('secondButtonLat').value);
    }
  }

  firstImageHandler(files: File[]) {
    if (files.length > 0) {
      const file = files[0];

      this.serviceFiles.files.push({ file: file, fileType: UPNFileType.FirstImage });

      this.loadingFirstImage = true;
      this.photoService.enqueueUploadPhoto(file, 'first image', { height: 1334, width: 750 }, false, false).subscribe(x => {
        this.form.patchValue({ firstImage: x.url });
        this.form.markAsDirty();
        this.loadingFirstImage = false;
        // this.mySwiper.update();
      });
    }
  }

  secondImageHandler(files: File[]) {
    if (files.length > 0) {
      const file = files[0];

      this.serviceFiles.files.push({ file: file, fileType: UPNFileType.SecondImage });

      this.loadingSecondImage = true;
      this.photoService.enqueueUploadPhoto(file, 'second image', { height: 1334, width: 750 }, false, false).subscribe(x => {
        this.form.patchValue({ secondImage: x.url });
        this.form.markAsDirty();
        this.loadingSecondImage = false;
         // this.mySwiper.update();
      });
    }
  }

  thirdImageHandler(files: File[]) {
    if (files.length > 0) {
      const file = files[0];

      this.serviceFiles.files.push({ file: file, fileType: UPNFileType.ThirdImage });

      this.loadingThirdImage = true;
      this.photoService.enqueueUploadPhoto(file, 'third image', { height: 1334, width: 750 }, false, false).subscribe(x => {
        this.form.patchValue({ thirdImage: x.url });
        this.form.markAsDirty();
        this.loadingThirdImage = false;
        //this.mySwiper.update();
      });
    }
  }

  cancel() {
    this.router.navigate(['/portal/upn']);
  }

  onDeactivate() {
    this.photoService.clearQueue();
  }

  viewTypeChange() {
    this.form.get('iframeUrl').setErrors(null);
    this.form.get('firstImage').setErrors(null);
    this.form.get('lat').setErrors(null);
    this.form.get('lng').setErrors(null);
  }

  firstButtonTypeChange() {
    this.form.get('firstButtonText').setErrors(null);
    this.form.get('firstButtonUrl').setErrors(null);
    this.form.get('firstButtonLat').setErrors(null);
    this.form.get('firstButtonLng').setErrors(null);

    this.form.get('firstButtonLocationTitle').setErrors(null);
    this.form.get('firstButtonLocationSubtitle').setErrors(null);

    // If there are coupons, and this is a new UPN, set the selector to the first coupon in the list
    if (this.coupons.length > 0 && this.form.get('firstButtonType').value === 'openCoupon'
      && this.form.controls.coupon1Select.value === 0) {
      this.form.controls.coupon1Select.patchValue(this.coupons[0].id);
    }
  }

  secondButtonTypeChange() {
    this.form.get('secondButtonText').setErrors(null);
    this.form.get('secondButtonUrl').setErrors(null);
    this.form.get('secondButtonLat').setErrors(null);
    this.form.get('secondButtonLng').setErrors(null);

    this.form.get('secondButtonLocationTitle').setErrors(null);
    this.form.get('secondButtonLocationSubtitle').setErrors(null);

    // If there are coupons, and this is a new UPN, set the selector to the first coupon in the list
    if (this.coupons.length > 0 && this.form.get('secondButtonType').value === 'openCoupon'
      && this.form.controls.coupon2Select.value === 0) {
      this.form.controls.coupon2Select.patchValue(this.coupons[0].id);
    }
  }

  enableBleChange() {
    this.form.get('bleTitle').setErrors(null);
    this.form.get('bleBody').setErrors(null);
  }

  protected setFormData(upn: UPN, userSubscription: any, savedData?: UPN): FormGroup {
    this.couponService.listCoupons().subscribe(data => { this.coupons = data; });

    const activeTerminal = {
      startDate: new Date(upn.activePeriod.startDate),
      endDate: new Date(upn.activePeriod.endDate)
    };

    const form = this.fb.group({
      id: this.id,
      title: [upn.title, [Validators.required]],
      activePeriod: [activeTerminal, [Validators.required]],
      type: [upn.type, [Validators.required]],
      cooldown: [upn.cooldown, [Validators.max(315360000), Validators.min(10), Validators.required]],
      autoswipe: [upn.autoswipe],
      locationTitle: [upn.locationTitle],
      locationSubtitle: [upn.locationSubtitle],
      firstButtonUrl: [upn.firstButtonUrl ? upn.firstButtonUrl : '', [Validators.pattern(/^(https?:\/\/)|(sms:\/\/)|(mailto:\/\/)/)]],
      firstButtonType: [upn.firstButtonType || ''],
      firstButtonText: [upn.firstButtonText, [Validators.maxLength(12)]],
      firstButtonLng: [upn.firstButtonLng],
      firstButtonLat: [upn.firstButtonLat],
      firstButtonLocationTitle: [upn.firstButtonLocationTitle],
      firstButtonLocationSubtitle: [upn.firstButtonLocationSubtitle],
      secondButtonUrl: [upn.secondButtonUrl ? upn.secondButtonUrl : '', [Validators.pattern(/^(https?:\/\/)|(sms:\/\/)|(mailto:\/\/)/)]],
      secondButtonType: [upn.secondButtonType || ''],
      secondButtonText: [upn.secondButtonText, [Validators.maxLength(12)]],
      secondButtonLng: [upn.secondButtonLng],
      secondButtonLat: [upn.secondButtonLat],
      secondButtonLocationTitle: [upn.secondButtonLocationTitle],
      secondButtonLocationSubtitle: [upn.secondButtonLocationSubtitle],
      useAudible: [upn.useAudible],
      regenerateAudio: [false],
      iframeUrl: [upn.iframeUrl, [
        ((): ValidatorFn => {
          return (control: AbstractControl): { [key: string]: any } | null => {
            let isValid = true;
            if (control.value) {
              isValid = control.value.toLowerCase().startsWith('https');
            }
            return isValid
              ? null
              : { 'non-secure': { value: control.value } };
          };
        })()
      ]
      ],
      firstImage: [upn.firstImage],
      secondImage: [upn.secondImage],
      thirdImage: [upn.thirdImage],
      dismissText: [upn.dismissText, [Validators.required, Validators.maxLength(5)]],
      lat: [upn.lat],
      lng: [upn.lng],
      bleEnabled: [upn.bleEnabled],
      bleTitle: [upn.bleTitle, [Validators.maxLength(40)]],
      bleSubtitle: [upn.bleSubtitle, [Validators.maxLength(40)]],
      bleBody: [upn.bleBody, [Validators.maxLength(120)]],
      bleShowOnTap: [upn.bleShowOnTap],
      coupon1Select: [upn.coupon1Id],
      coupon2Select: [upn.coupon2Id],
    });

    this.sanitizeUrl(form);
    this._initializeGoogleMaps(form);

    if (userSubscription.subscriptionStartDate && userSubscription.subscriptionEndDate) {
      form.controls.activePeriod.patchValue({
        startDate: new Date(userSubscription.subscriptionStartDate),
        endDate: new Date(userSubscription.subscriptionEndDate)
      });
      form.controls.activePeriod.disable();
    } else {
      this.showServicePeriod = true;
    }

    form.controls['iframeUrl'].valueChanges.subscribe(_ => this.sanitizeUrl(form));

    return form;
  }

  protected onBuildSuccess(): string {
    return `Your UPN has been ${this.id ? 'updated' : 'purchased'} successfully!`;
  }

  protected getInitialDataForNewItem(): Observable<UPN> {
    return of(<UPN>{
      id: null,
      title: '',
      autoswipe: true,
      cooldown: 30,
      type: 'Image',
      locationTitle: 'Location Title',
      locationSubtitle: 'Location Subtitle',
      lat: 30.2412414,
      lng: 45.3332223,
      iframeUrl: 'https://www.youtube.com/embed/t5CSY5eKkeQ',
      firstImage: '',
      dismissText: 'Close',
      firstButtonUrl: '',
      firstButtonType: '',
      firstButtonText: '',
      firstButtonLat: null,
      firstButtonLng: null,
      firstButtonLocationTitle: '',
      firstButtonLocationSubtitle: '',
      secondButtonUrl: '',
      secondButtonType: '',
      secondButtonText: '',
      secondButtonLat: null,
      secondButtonLng: null,
      secondButtonLocationTitle: '',
      secondButtonLocationSubtitle: '',
      activePeriod: {
        startDate: new Date().toString(),
        endDate: moment()
          .add(30, 'days')
          .toDate()
          .toString()
      },
      upnJson: null,
      coupon1Id: 0,
      coupon2Id: 0,
      useAudible: false
    });
  }

  protected loadServiceFiles(data: UPN) {
    
    for (let i = 0; i < data.serviceFiles?.files.length; i++) {

      switch(data.serviceFiles.files[i].fileType) {

        case UPNFileType.FirstImage:
          this.firstImageHandler([data.serviceFiles.files[i].file]);
          break;
        
        case UPNFileType.SecondImage:
          this.secondImageHandler([data.serviceFiles.files[i].file]);
          break;

        case UPNFileType.ThirdImage:
          this.thirdImageHandler([data.serviceFiles.files[i].file]);
          break;

        default: 
          break;
      }
    }
  }

  private _initializeGoogleMaps(form: FormGroup) {
    if (!Environment.production) {
      return;
    }

    this.map = new google.maps.Map(this.mapElement.nativeElement, {
      center: { lat: +form.get('lat').value, lng: +form.get('lng').value },
      zoom: 8,
      disableDefaultUI: true
    });

    this.marker = new google.maps.Marker({
      position: { lat: +form.get('lat').value, lng: +form.get('lng').value },
      map: this.map
    });
  }

  private _updateFormByUPNType(type: string) {
    if (type === 'Image') {
      this.form.get('iframeUrl').setValue(null);
      this.form.get('lat').setValue(null);
      this.form.get('lng').setValue(null);
      this.form.get('locationTitle').setValue(null);
      this.form.get('locationSubtitle').setValue(null);
    } else if (type === 'Web View') {
      this.form.get('autoswipe').setValue(null);
      this.form.get('firstImage').setValue(null);
      this.form.get('secondImage').setValue(null);
      this.form.get('thirdImage').setValue(null);
      this.form.get('lat').setValue(null);
      this.form.get('lng').setValue(null);
      this.form.get('locationTitle').setValue(null);
      this.form.get('locationSubtitle').setValue(null);
    } else {
      this.form.get('iframeUrl').setValue(null);
      this.form.get('autoswipe').setValue(null);
      this.form.get('firstImage').setValue(null);
      this.form.get('secondImage').setValue(null);
      this.form.get('thirdImage').setValue(null);
    }

    switch (this.form.get('firstButtonType').value) {
      case 'openUrl':
        this.form.get('firstButtonLat').setValue(null);
        this.form.get('firstButtonLng').setValue(null);
        this.form.get('firstButtonLocationTitle').setValue(null);
        this.form.get('firstButtonLocationSubtitle').setValue(null);
        break;
      case 'openCoupon':
        this.form.get('firstButtonLat').setValue(null);
        this.form.get('firstButtonLng').setValue(null);
        this.form.get('firstButtonLocationTitle').setValue(null);
        this.form.get('firstButtonLocationSubtitle').setValue(null);
        break;
      case 'openMaps':
        this.form.get('firstButtonUrl').setValue(null);
        break;
      default:
        this.form.get('firstButtonUrl').setValue(null);
        this.form.get('firstButtonText').setValue(null);
        this.form.get('firstButtonLat').setValue(null);
        this.form.get('firstButtonLng').setValue(null);
        this.form.get('firstButtonType').setValue(null);
        this.form.get('firstButtonLocationTitle').setValue(null);
        this.form.get('firstButtonLocationSubtitle').setValue(null);
        break;
    }

    switch (this.form.get('secondButtonType').value) {
      case 'openUrl':
        this.form.get('secondButtonLat').setValue(null);
        this.form.get('secondButtonLng').setValue(null);
        this.form.get('secondButtonLocationTitle').setValue(null);
        this.form.get('secondButtonLocationSubtitle').setValue(null);
        break;
      case 'openCoupon':
        this.form.get('secondButtonLat').setValue(null);
        this.form.get('secondButtonLng').setValue(null);
        this.form.get('secondButtonLocationTitle').setValue(null);
        this.form.get('secondButtonLocationSubtitle').setValue(null);
        break;
      case 'openMaps':
        this.form.get('secondButtonUrl').setValue(null);
        break;
      default:
        this.form.get('secondButtonUrl').setValue(null);
        this.form.get('secondButtonText').setValue(null);
        this.form.get('secondButtonLat').setValue(null);
        this.form.get('secondButtonLng').setValue(null);
        this.form.get('secondButtonType').setValue(null);
        this.form.get('secondButtonLocationTitle').setValue(null);
        this.form.get('secondButtonLocationSubtitle').setValue(null);
        break;
    }
  }

  private _formatDate(date: Date): string {
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
  }

  private _removeDragAndDropEventListeners() {
    if (!this.firstDropZone || !this.secondDropZone || !this.thirDropZone) {
      return;
    }

    this._dropZoneEventListerners.forEach(eventName => {
      this.firstDropZone.removeEventListener(eventName, this._preventDefaults, false);
      this.secondDropZone.removeEventListener(eventName, this._preventDefaults, false);
      this.thirDropZone.removeEventListener(eventName, this._preventDefaults, false);
    });

    ['dragenter', 'dragover'].forEach(eventName => {
      this.firstDropZone.removeEventListener(eventName, this._highlightFirstZone, false);
      this.secondDropZone.removeEventListener(eventName, this._highlightSecondZone, false);
      this.thirDropZone.removeEventListener(eventName, this._highlightThirdZone, false);
    });

    ['dragleave', 'drop'].forEach(eventName => {
      this.firstDropZone.removeEventListener(eventName, this._unHighlightZones, false);
      this.secondDropZone.removeEventListener(eventName, this._unHighlightZones, false);
      this.thirDropZone.removeEventListener(eventName, this._unHighlightZones, false);
    });

    this.firstDropZone.removeEventListener('drop', this._handleFirstDrop, false);
    this.secondDropZone.removeEventListener('drop', this._handleSecondDrop, false);
    this.thirDropZone.removeEventListener('drop', this._handleThirdDrop, false);
  }

  ngOnDestroy() {
    this.ngdestroy.next();
    this.ngdestroy.complete();

    this._removeDragAndDropEventListeners();
  }
}
